import { ListboxOptionMeta } from './ListboxOptionMeta';

// TODO: in v9, move styled() from ListboxOptionMeta.jsx to here
export var StyledListboxOptionMeta = ListboxOptionMeta;